export default "__VITE_ASSET__Ds$b60Ph__"